import { render, staticRenderFns } from "./PaymentsBuilder.vue?vue&type=template&id=1b8cd6a1"
import script from "./PaymentsBuilder.vue?vue&type=script&lang=js"
export * from "./PaymentsBuilder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/devstark/spreadsimple/spreadsimple-app/main-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b8cd6a1')) {
      api.createRecord('1b8cd6a1', component.options)
    } else {
      api.reload('1b8cd6a1', component.options)
    }
    module.hot.accept("./PaymentsBuilder.vue?vue&type=template&id=1b8cd6a1", function () {
      api.rerender('1b8cd6a1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-builder/PaymentsBuilder.vue"
export default component.exports